import e from "./createTheme.js";
const a = e();
export {
  a as default
};
